/**
 * Utilitaire de gestion des cookies pour le site NIGHTRIDERZ
 */

/**
 * Définit un cookie avec une durée de vie spécifiée
 * @param {string} name - Nom du cookie
 * @param {string} value - Valeur du cookie
 * @param {number} days - Durée de vie en jours
 */
export function setCookie(name, value, days = 365) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
}

/**
 * Récupère la valeur d'un cookie par son nom
 * @param {string} name - Nom du cookie à récupérer
 * @returns {string|null} - Valeur du cookie ou null s'il n'existe pas
 */
export function getCookie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
}

/**
 * Supprime un cookie par son nom
 * @param {string} name - Nom du cookie à supprimer
 */
export function deleteCookie(name) {
  setCookie(name, '', -1);
}

/**
 * Vérifie si le consentement aux cookies a été donné
 * @returns {boolean} - true si le consentement a été donné
 */
export function hasCookieConsent() {
  return getCookie('cookie-consent') === 'accepted';
}
